import {Card, Col, Divider, Row, Spin} from "antd";
import {useEffect, useState} from "react";
import Api from "../../../services/Api";
import dayjs from "dayjs";
import flexCurrency from "../../../utils/FlexCurrency";

const GelirToplamComponent = () => {
    const [tarifeData, setTarifeData] = useState(null);
    const [restaurantData, setRestaurantData] = useState([]);
    const [fotokapanData, setFotokapanData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const baslangicTarihi = dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS");
        const bitisTarihi = dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS");

        Promise.all([
            Api.get("/api/Report/GetBosAppDailyReport?RaporTarihi=" + dayjs().format("YYYY-MM-DD")),
            Api.get(`/api/ToyaPos/ZraporuAvansli?baslangicTarihi=${encodeURIComponent(baslangicTarihi)}&bitisTarihi=${encodeURIComponent(bitisTarihi)}`),
            Api.get(`/api/ToyaPos/ZraporuAlinmislarAvansli?baslangicTarihi=${encodeURIComponent(baslangicTarihi)}&bitisTarihi=${encodeURIComponent(bitisTarihi)}`),
            Api.get("/api/FotoKapan/GetBugunKazanclar"),
        ]).then(([tarifeRes, res1, res2, fotoRes]) => {
            setTarifeData(tarifeRes.data);
            setRestaurantData([...res1.data, ...res2.data]);
            setFotokapanData(fotoRes.data);
        }).catch(err => {
            console.error("Gelir toplam verisi alınırken hata:", err);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const tarifeToplam = tarifeData?.toplamKazanilanTutar || 0;

    const restaurantToplam = restaurantData.reduce((acc, item) => {
        return acc + parseFloat(item.Nakit || 0) + parseFloat(item.Kart || 0);
    }, 0);

    const fotokapanToplam = fotokapanData
        ? Object.values(fotokapanData).reduce((acc, station) => acc + (Number(station.amount) || 0), 0)
        : 0;

    const genelToplam = tarifeToplam + restaurantToplam + fotokapanToplam;

    const kalemler = [
        {label: "Dağ Kızağı", tutar: tarifeToplam},
        {label: "Restaurant", tutar: restaurantToplam},
        {label: "Foto Kapan", tutar: fotokapanToplam},
    ];

    if (loading) {
        return (
            <Card title={"Dağ Kızağı Toplamları"} size={"small"}>
                <div style={{textAlign: "center", padding: 20}}>
                    <Spin/>
                </div>
            </Card>
        );
    }

    return (
        <Card title={"Gelir Toplamları"} size={"small"}>
            <Row gutter={[0, 0]}>
                {kalemler.map((kalem, index) => (
                    <Col span={24} key={index}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 8px",
                            borderBottom: "1px solid #f0f0f0",
                        }}>
                            <span style={{fontWeight: "bold", fontSize: 16}}>{kalem.label}</span>
                            <span style={{fontWeight: "bold", fontSize: 16}}>{flexCurrency(kalem.tutar)} TL</span>
                        </div>
                    </Col>
                ))}
            </Row>

            <Divider style={{margin: "12px 0"}}/>

            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px",
            }}>
                <span style={{fontWeight: "bold", fontSize: 18}}>GENEL TOPLAM</span>
                <span style={{fontWeight: "bold", fontSize: 24, color: "#3f8600"}}>{flexCurrency(genelToplam)} TL</span>
            </div>
        </Card>
    );
};

export default GelirToplamComponent;
